import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const AdminReprintSlice = createSlice({
  name: "AdminReprintSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    AdminReprint: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    successAdminReprint: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureAdminReprint: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearAdminReprint: (state) => {
      state.data = {};
    },
  },
});

export const {
  AdminReprint,
  failureAdminReprint,
  successAdminReprint,
  clearAdminReprint,
} = AdminReprintSlice.actions;

export default AdminReprintSlice.reducer;
